import { frontendURL } from '../../../../helper/URLHelper';

import SettingsWrapper from '../SettingsWrapper.vue';
import CommunicationConnectionHome from './Index.vue';
import WhatsappAccounts from './WhatsappAccounts.vue';
import InboxMapping from './InboxMapping.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/communication'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'communication_connection_index',
          meta: {
            permissions: ['administrator'],
          },
          component: CommunicationConnectionHome,
        },
        {
          path: 'whatsapp-accounts',
          name: 'communication_whatsapp_accounts',
          meta: {
            permissions: ['administrator'],
          },
          component: WhatsappAccounts,
        },
        {
          path: 'inbox-mapping',
          name: 'communication_inbox_mapping',
          meta: {
            permissions: ['administrator'],
          },
          component: InboxMapping,
        },
      ],
    },
  ],
};
